module.exports = __webpack_public_path__ + "img/up_04.52dc8bfe.png";